import { createRootRoute, Outlet } from "@tanstack/react-router";
import { ThemeProvider } from "next-themes";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/auth";

// NOTE: WebSocketProvider + SessionProvider (src/providers/) are intentionally
// NOT mounted here.  The app uses the older ws.ts singleton (initialised in
// AppShell via connect/disconnect) which already handles auth, channels,
// protocol bridging, and the zustand store.  Mounting both providers caused
// duplicate WebSocket connections to the backend.  The provider files are kept
// in-tree for potential future migration.

function RootInner() {
  return (
    <TooltipProvider>
      <Outlet />
      <Toaster position="bottom-right" />
    </TooltipProvider>
  );
}

function RootLayout() {
  return (
    <AuthProvider>
      <ThemeProvider attribute="class" defaultTheme="dark" enableSystem>
        <RootInner />
      </ThemeProvider>
    </AuthProvider>
  );
}

export const Route = createRootRoute({
  component: RootLayout,
});
